export default [
  {
    name: "Exports",
    path: "/exports",
    component: () => import("@/modules/exports/pages/Exports"),
    meta: {
      ability: [
        {
          resource: "exports",
          actions: ["read"],
        },
      ],
    },
  },
  {
    name: "Add Request",
    path: "/exports/add",
    component: () => import("@/modules/exports/pages/ExportsDetails"),
  },
  {
    name: "Edit Request",
    path: "/exports/view/:id?",
    component: () => import("@/modules/exports/pages/ExportsDetails"),
    meta: {
      ability: [
        {
          resource: "exports/:id",
          actions: ["read"],
        },
      ],
    },
  },
];
